(() => {
    const form = document.querySelector('.vehicle-search-form');
    if (!form) {
        return;
    }

    const vars = window.vehicleSearchVars || {};
    // Legacy code - populates checkbox checked states
    for (const name in vars) {
        const data = vars[name];

        if (data.Type === 'set') {
            data.Value.split(',').forEach((value) => {
                const input = form.querySelector(`input[name="${name}[${value}]"]`);
                if (input) {
                    input.checked = true;
                }
            })
        } else if (data.Type === 'range') {
            let min, max;
            [min, max] = data.Value.split('-');
            const fromSelect = form.querySelector(`select[name="${name.toLowerCase()}from"]`);
            if (fromSelect) {
                fromSelect.value = min;
            }

            const toSelect = form.querySelector(`select[name="${name.toLowerCase()}to"]`);
            if (toSelect) {
                toSelect.value = max;
            }
        } else if (data.Type === 'basic') {
            const input = form.querySelector(`input[name="${name}"]`);
            if (input) {
                input.checked = true;
            }
        }
    }


    form.querySelectorAll('.vehicle-search-form__checkbox-group').forEach((group) => {
        const toggleAll = group.querySelector('input[type="checkbox"][data-toggle-all]');
        const checkboxes = group.querySelectorAll('input[type="checkbox"]:not([data-toggle-all])');

        const updateToggleAllState = () => {
            const checked = group.querySelectorAll('input[type="checkbox"]:not([data-toggle-all]):checked');
            toggleAll.checked = checked.length === 0 || checked.length === checkboxes.length;
        }

        const handleToggleAllChange = (event) => {
            checkboxes.forEach(checkbox => checkbox.checked = event.target.checked);
        }

        toggleAll.addEventListener('change', handleToggleAllChange);
        checkboxes.forEach(checkbox => checkbox.addEventListener('change', updateToggleAllState));
        updateToggleAllState();
    });


    const allMakesCheckbox = form.querySelector('input[type="checkbox"][name="make"]');
    const modelCheckboxes = form.querySelectorAll('input[type="checkbox"][name^="Model"]:not([data-toggle-all])');
    const updateVisibleModels = () => {
        modelCheckboxes.forEach((checkbox) => {
            if (allMakesCheckbox.checked || form.querySelector(`input[type="checkbox"][name="Make[${checkbox.getAttribute('data-make')}]"]`)?.checked) {
                checkbox.closest('.vehicle-search-form__checkbox-item').classList.remove('h');
            } else {
                checkbox.closest('.vehicle-search-form__checkbox-item').classList.add('h');
                checkbox.checked = false;
            }
        });

        if (allMakesCheckbox.checked || form.querySelectorAll(`input[type="checkbox"][name^="Make"]:checked`).length > 1) {
            form.classList.add('vehicle-search-form--make-hint-visible');
        } else {
            form.classList.remove('vehicle-search-form--make-hint-visible');
        }
    }
    form.querySelectorAll('input[type="checkbox"][name^="Make"], input[type="checkbox"][name="make"]').forEach((checkbox) => {
        checkbox.addEventListener('change', updateVisibleModels);
    });
    updateVisibleModels();


    form.querySelectorAll('.vehicle-search-form__dropdown-range-group').forEach((group) => {
        const originalOptions = new Map();
        group.querySelectorAll('select').forEach((select) => {
            originalOptions.set(select, Array.from(select.options).map(option => option.cloneNode(true)));
        });

        const updateVisibleRangeSelections = () => {
            const minSelect = group.querySelector('select[name$="from"]');
            const maxSelect = group.querySelector('select[name$="to"]');

            if (!minSelect || !maxSelect) {
                return;
            }

            const minValue = minSelect.value;
            const maxValue = maxSelect.value;
            const isMileageRange = minSelect.name.includes('mileage') || maxSelect.name.includes('mileage');

            const updateSelect = (select, otherValue, isMaxSelect) => {
                const currentValue = select.value;
                select.innerHTML = '';
                const originalOptionsToRestore = originalOptions.get(select);

                if (!otherValue || otherValue === '') {
                    originalOptionsToRestore.forEach(option => select.appendChild(option.cloneNode(true)));
                } else {
                    originalOptionsToRestore.forEach(option => {
                        if (option.value === '') {
                            select.appendChild(option.cloneNode(true));
                        } else {
                            const optionValue = parseFloat(option.value);
                            const constraintValue = parseFloat(otherValue);
                            let shouldInclude;

                            if (isMaxSelect) {
                                shouldInclude = isMileageRange ?
                                    optionValue > constraintValue :
                                    optionValue >= constraintValue;
                            } else {
                                shouldInclude = isMileageRange ?
                                    optionValue < constraintValue :
                                    optionValue <= constraintValue;
                            }

                            if (shouldInclude) {
                                select.appendChild(option.cloneNode(true));
                            }
                        }
                    });
                }

                if (currentValue && select.querySelector(`option[value="${currentValue}"]`)) {
                    select.value = currentValue;
                }
            };

            updateSelect(maxSelect, minValue, true);
            updateSelect(minSelect, maxValue, false);
        };

        group.querySelectorAll('select').forEach((select) => select.addEventListener('change', updateVisibleRangeSelections));

        updateVisibleRangeSelections();
    });

    document.querySelectorAll('.vehicle-search-filters__pill').forEach((pill) => {
        pill.addEventListener('click', () => {
            const field = pill.getAttribute('data-target');
            const value = pill.getAttribute('data-value');
            let detailsWidget = form.querySelector(`.vehicle-search-form__filter[data-field="${field}"]`);

            if (!detailsWidget && ['UpfrontWheelchair', 'WheelchairDriver'].indexOf(field) !== -1) {
                detailsWidget = form.querySelector(`.vehicle-search-form__filter[data-field="VehicleSize"]`);
            }

            if (!detailsWidget) {
                return;
            }

            if (!value) {
                form.querySelectorAll('.vehicle-search-form__filter').forEach((filter) => filter.removeAttribute('open'));
                detailsWidget.setAttribute('open', '');
                setTimeout(() => {
                    detailsWidget.scrollIntoView();
                }, 50);
                return;
            }

            if (value === '*') {
                detailsWidget.querySelectorAll('select').forEach((select) => {
                    select.value = '';
                });
                detailsWidget.querySelectorAll(`input[name="${field}"]`).forEach((input) => {
                    input.checked = false;
                });
                form.submit();
                return;
            }

            const input = detailsWidget.querySelector(`input[name="${field}[${value}]"]`);
            if (input) {
                input.checked = false;
                form.submit();
            }
        });
    });
})();
